import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-active',
    templateUrl: './active.component.html'
})
export class ActiveComponent {
    @Input() active: boolean;
}
